// src/App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Friends from './pages/Friends';
import Upload from './pages/Upload';
import Chats from './pages/Chats';
import Profile from './pages/Profile';
import PageNotFound from './pages/PageNotFound';
import CreatePoll from './components/CreatePoll';
import CreateQoute from './components/CreateQoute';
import Login from './pages/Login';

// Import AuthProvider instead of AuthContextProvider
import { AuthProvider } from './context/AuthProvider.js';
import MyNavbar from './components/MyNavbar';

export default function App() {
  return (
    <>
    <MyNavbar></MyNavbar>
    <AuthProvider> {/* Wrap everything with AuthProvider to handle user state */}
      <Routes>
        <Route path="/" index element={<Home />} />
        <Route path="friends" element={<Friends />} />
        <Route path="/create" element={<Upload />}>
          <Route index element={<CreateQoute />} />
          <Route path="CreatePoll" element={<CreatePoll />} />
          <Route path="CreateQoute" element={<CreateQoute />} />
        </Route>
        <Route path="chats" element={<Chats />} />
        <Route path="myprofile" element={<Profile />} />
        <Route path="authentication" element={<Login />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </AuthProvider>
    </>
  );
}
